import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
let pixelLoaded = false;
export function App() {
  useEffect(() => {
    document.title = 'Pack Bases del Entrenamiento de Fuerza';
    document.documentElement.setAttribute('lang', 'es');
    document.documentElement.setAttribute('translate', 'no');
    const meta = document.createElement('meta');
    meta.name = 'google';
    meta.content = 'notranslate';
    document.head.appendChild(meta);
    // Meta Pixel — load once only
    if (pixelLoaded || (window as any).fbq) return;
    pixelLoaded = true;
    const pixelId = '804808849254877';
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  }, []);
  return <LandingPage data-id="element-0" />;
}